import WavesurferPlayer from '@wavesurfer/react';
import { useRef } from 'react';

import { AudioWaveformProps } from './types';

const AudioWaveform = ({
  audioUrl,
  onReady,
  onPlay,
  onPause,
  isPlaying,
}: AudioWaveformProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={containerRef} className="w-full h-4 flex-1 ml-1">
      <WavesurferPlayer
        height={16}
        fillParent
        normalize
        waveColor="#E5E7EB" // Tailwind gray-200
        progressColor="#9CA3AF" // Tailwind gray-400
        cursorColor="rgba(0,0,0,0)"
        cursorWidth={1}
        url={audioUrl || '/audio/sample.wav'}
        hideScrollbar
        dragToSeek
        barWidth={2}
        barGap={4}
        barRadius={100}
        onReady={onReady}
        onPlay={onPlay}
        onPause={onPause}
      />
    </div>
  );
};

export default AudioWaveform;
